module.exports = __webpack_public_path__ + "static/media/PortadaInpur.3844af9e.png";